import BIMESSAGES from 'core/data-model/constants/bi-messages'
import VALUES from 'core/data-model/constants/values'
import { getBasicPlanCodeForMRTA } from 'quick-quote/product-mrta/coverage-plan/selectors.utils'

import { formattedHeaderWithStyles, productInfoHeaderStyles } from '../../common/components/product-information-header'

export const render = (displayProduct, redline) => {
  let header1
  const header2 = `${displayProduct.nameThai} (${displayProduct.code})`

  const basicPlanCode = getBasicPlanCodeForMRTA(displayProduct)
  switch (basicPlanCode) {
    case VALUES.MRTA_CODE.MRTA_FULL:
      header1 = BIMESSAGES.MRTA_FULL_EN_NAME
      break
    case VALUES.MRTA_CODE.MRTA_PLUS:
      header1 = BIMESSAGES.MRTA_PLUS_EN_NAME
      break
    case VALUES.MRTA_CODE.MRTA_TRUNCATE:
      header1 = BIMESSAGES.MRTA_TRUNCATE_EN_NAME
      break
    default:
      header1 = displayProduct.name
      break
  }

  return formattedHeaderWithStyles(header1, header2, redline, productInfoHeaderStyles)
}
